import React from 'react';
/**
 * Passthrough wrapper kept for backward-compatibility with existing imports.
 * The previous IntersectionObserver + getBoundingClientRect implementation
 * was causing ~1.8s of forced reflow on mid-range mobile devices, which
 * dominated TBT/main-thread time on Lighthouse. Render-time animations
 * are now disabled in favor of an instant, paint-friendly first load.
 *
 * Props are accepted but ignored to avoid touching every call site.
 */
export function FadeIn({
  children,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'left' | 'right' | 'none';
}) {
  if (className) {
    return <div className={className} data-id="element-57">{children}</div>;
  }
  return <>{children}</>;
}